import type { UniversalSearchRequestBody } from '@weberus/shared-types';
import { createQueryKeys } from '@lukemorales/query-key-factory';

import { fetchGlobalListUniversalSearch, fetchGlobalListUniversalSearchMap } from '@/app/(pages)/results/api';
import { QueryKeys } from './query-keys';

export const globalListQueryKeys = createQueryKeys(QueryKeys.globalList, {
  /** [V1] 해외숙소 조회 */
  getGlobalListUniversalSearch: (
    args: UniversalSearchRequestBody,
    hashedMemberNo: string | undefined,
    pageKey?: string | undefined,
    headers?: Headers,
  ) => ({
    queryKey: [args, hashedMemberNo, pageKey],
    queryFn: ({ pageParam = 1 }) => fetchGlobalListUniversalSearch({ ...args, page: pageParam }, headers),
  }),

  /** [V1] 해외숙소 지도 조회 */
  getGlobalListUniversalSearchMap: (args: UniversalSearchRequestBody, hashedMemberNo: string | undefined) => ({
    queryKey: [args, hashedMemberNo],
    queryFn: ({ pageParam = 1 }) => fetchGlobalListUniversalSearchMap({ ...args, page: pageParam }),
  }),
});
